/* eslint-disable no-bitwise */
import { CH_EMAIL, CH_KIVRA, CH_LETTER, SelectionCoverage } from 'src/modules/sending/contexts/sendingWizardContext';

// Delad reach-logik för leveranssteget och sammanfattningen (forka inte – ändra här = ändra på båda ställena).
// Kanal-bit per leveransmetod-nyckel, så antal nåbara kan räknas ur urvalets kanal-täckning (coverage.masks).
export const DELIVERY_BITS: Record<string, number> = { mail: CH_EMAIL, kivra: CH_KIVRA, letter: CH_LETTER };

export const bitOfMethod = (key: string): number => DELIVERY_BITS[key] ?? 0;

// Färg per leveransmetod – matchar ikonerna/loggorna: e-post primary-blå, Kivra grön, PostNord-blå, PDF grå.
// Delas av leveranssteget (stapel) och sammanfattningen (prickar) så färgspråket är detsamma.
export const CHANNEL_COLOR: Record<string, string> = { mail: '#00447e', kivra: '#70b729', letter: '#00a0d6', pdf: '#78909c' };

// Antal medlemmar som nås av minst en av kanalerna i "bits" (utifrån urvalets kanal-täckning).
export const reachOf = (coverage: SelectionCoverage | null, bits: number): number =>
  coverage ? coverage.masks.reduce((sum, cnt, b) => sum + ((b & bits) !== 0 ? cnt : 0), 0) : 0;

export interface DeliverySegment {
  key: string;
  // Antal NYA medlemmar som denna metod når (utöver de som redan nåtts av tidigare metoder i ordningen).
  inc: number;
}

// Per vald metod i prioritetsordning: hur många NYA medlemmar den når.
// PDF-nedladdning ('pdf') saknar kanal-bit och når alla återstående mottagare (du hanterar dem själv).
export const computeSegments = (order: string[], coverage: SelectionCoverage | null): DeliverySegment[] => {
  const total = coverage?.total ?? 0;
  let accBits = 0;
  let reached = 0;
  return order.map((key) => {
    if (key === 'pdf') {
      const inc = Math.max(0, total - reached);
      reached = total;
      return { key, inc };
    }
    accBits |= bitOfMethod(key);
    const after = reachOf(coverage, accBits);
    const inc = Math.max(0, after - reached);
    reached = Math.max(reached, after);
    return { key, inc };
  });
};
